
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetojyotilingadarshan() {



    const cardData =
    {
        keyword: 'Pune to 5 Jyotirlinga Darshan Bus Hire',
        heading: 'Amruta Travels: Pune to 5 Jyotirlinga Darshan Bus Hire',
        headingDescription: 'Amruta Travels offers Pune to 5 Jyotirlinga  Bus Rental Service, providing a reliable and comfortable transportation solution for your coastal getaways. Whether you are planning a family vacation, corporate retreat, or group tour, our well-maintained buses ensure a smooth and enjoyable journey to Ganpatipule. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your travel to Ganpatipule simple and stress-free. Choose from our range of buses, including 14-seater, 17-seater, 20-seater, and 25-seater options, to suit your group size. Book your Pune to Ganpatipule Bus with Amruta Travels and embark on a journey of comfort and relaxation!',


        top: '5 Jyotirlinga Darshan places in Maharashtra with Amruta Travels',

   "topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga – Nashik",
    "description": "Located in Trimbak, near Nashik, Trimbakeshwar is one of the holiest Jyotirlingas. Nestled at the source of the Godavari River, this ancient temple is unique as it features three lingams symbolizing Brahma, Vishnu, and Mahesh. Surrounded by scenic hills, it is a center for rituals and spiritual practices."
  },
  {
    "title": "Bhimashankar Jyotirlinga – Pune",
    "description": "Situated in the Sahyadri ranges near Pune, Bhimashankar Temple is surrounded by lush forests and wildlife. It’s believed to be the place where Lord Shiva defeated the demon Tripurasura. Pilgrims flock here for both religious devotion and the peaceful natural beauty."
  },
  {
    "title": "Grishneshwar Jyotirlinga – Aurangabad",
    "description": "Located near the famous Ellora Caves, Grishneshwar is the last of the 12 Jyotirlingas. The temple is built in red volcanic rock and features classic Maratha architecture. It's a must-visit for those combining spiritual and heritage tourism."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga – Hingoli",
    "description": "Regarded as the first Jyotirlinga, Aundha Nagnath in Hingoli is an ancient temple steeped in legend. It is said to have been constructed by the Pandavas during their exile. The temple's intricate carvings and serene ambiance make it a key pilgrimage destination."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga – Beed",
    "description": "Parli Vaijnath, located in the Beed district, is a prominent Jyotirlinga believed to bless devotees with good health. The temple combines both spiritual reverence and historic importance, with a beautiful structure built of stone and wood in the Hemadpanthi style."
  }
],



   "services": [
    {
      "name": "Pune to Trimbakeshwar Bus Hire Nashik",
      "description": "Travel comfortably from Pune to Trimbakeshwar with Amruta Travels' bus hire service. Our buses are fully air-conditioned, spacious, and ideal for groups visiting the Trimbakeshwar Temple in Nashik. Experience a safe, enjoyable, and seamless journey."
    },
    {
      "name": "Pune to Aundha Nagnath Bus on Rent",
      "description": "Amruta Travels offers bus rental services from Pune to Aundha Nagnath. Whether you're traveling for a pilgrimage or a group outing, our buses provide comfort, safety, and reliable service for a smooth trip."
    },
    {
      "name": "Pune to Bhimashankar Bus Hire on Rent",
      "description": "Book a bus from Pune to Bhimashankar with Amruta Travels for a comfortable and hassle-free journey. Our buses are ideal for pilgrimage trips, offering air-conditioning and experienced drivers to make your journey peaceful and enjoyable."
    },
    {
      "name": "Pune to Grishneshwar Jyotirlinga Bus On Rent",
      "description": "Travel to the sacred Grishneshwar Jyotirlinga with Amruta Travels' bus hire services. Our air-conditioned buses offer comfort, safety, and a relaxed experience while visiting one of the 12 Jyotirlingas in India."
    },
    {
      "name": "5 Jyotirlinga in Maharashtra Tour Package from Pune",
      "description": "Embark on a spiritual journey to visit the 5 Jyotirlingas in Maharashtra with Amruta Travels' exclusive tour package. Our package includes bus rentals, accommodation, and a guide for a comprehensive and comfortable tour."
    },
    {
      "name": "Tempo Traveller on Rent for 5 Jyotirlinga Darshan",
      "description": "Amruta Travels offers Tempo Travellers for the 5 Jyotirlinga Darshan tour. Our vehicles are perfect for small groups, providing AC comfort and ample space, ensuring a comfortable trip for your religious pilgrimage."
    },
    {
      "name": "Pune to Jyotirlinga Darshan Tour Package with Bus",
      "description": "Book a complete tour package with Amruta Travels for your Jyotirlinga Darshan from Pune. Our bus services include a guided tour, comfortable seating, and air-conditioned buses for a perfect religious trip."
    },
    {
      "name": "Mini Bus on Rent for Jyotirlinga Darshan",
      "description": "Travel in a mini bus with Amruta Travels for your Jyotirlinga Darshan. These vehicles are ideal for small groups, offering air-conditioning, comfortable seating, and a reliable driver for a seamless pilgrimage experience."
    },
    {
      "name": "Pune to Bhimashankar Mini Bus on Rent",
      "description": "For your pilgrimage to Bhimashankar, Amruta Travels offers mini bus rentals from Pune. Our mini buses are perfect for smaller groups, offering comfort and AC convenience for your spiritual journey."
    },
    {
      "name": "Pune to Trimbakeshwar Tempo Traveller on Rent",
      "description": "Book a Tempo Traveller from Pune to Trimbakeshwar with Amruta Travels. Our vehicles are air-conditioned, spacious, and perfect for small groups visiting the Trimbakeshwar Temple, offering both comfort and reliability."
    },
    {
      "name": "Pune to Aundha Nagnath Tempo Traveller on Rent",
      "description": "Travel to Aundha Nagnath with Amruta Travels' Tempo Traveller rentals. Our vehicles are designed for small groups, offering comfort, air-conditioning, and ample space for a smooth, hassle-free journey."
    },
    {
      "name": "Pune to Grishneshwar Tempo Traveller on Rent",
      "description": "Book a Tempo Traveller from Pune to Grishneshwar with Amruta Travels. Our fleet of well-maintained vehicles ensures a comfortable, air-conditioned journey to one of the most revered Jyotirlingas in Maharashtra."
    }
  ],
  "tableData": [
    ["Pune to Trimbakeshwar Bus Hire Nashik", "Pune to Aundha Nagnath Bus on Rent"],
    ["Pune to Bhimashankar Bus Hire on Rent", "Pune to Grishneshwar Jyotirlinga Bus On Rent"],
    ["5 Jyotirlinga in Maharashtra Tour Package from Pune", "Tempo Traveller on Rent for 5 Jyotirlinga Darshan"],
    ["Pune to Jyotirlinga Darshan Tour Package with Bus", "Mini Bus on Rent for Jyotirlinga Darshan"],
    ["Pune to Bhimashankar Mini Bus on Rent", "Pune to Trimbakeshwar Tempo Traveller on Rent"],
    ["Pune to Aundha Nagnath Tempo Traveller on Rent", "Pune to Grishneshwar Tempo Traveller on Rent"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Spiritual and Comfortable Journey to 5 Jyotirlingas",
    "WhyChoosedescription": "Amruta Travels offers Pune to 5 Jyotirlinga Darshan Bus Hire, providing a comfortable, safe, and spiritual journey to visit the five sacred Jyotirlingas. Our buses are equipped with spacious seating, air conditioning, and modern amenities to ensure a pleasant and restful trip."
  },
  {
    "WhyChooseheading": "Ideal for Religious Pilgrimages and Group Tours",
    "WhyChoosedescription": "Our buses are perfect for religious groups, families, or pilgrims embarking on the sacred journey to the 5 Jyotirlingas. We ensure a smooth and comfortable travel experience for all passengers as they visit these revered spiritual sites."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are well-trained, courteous, and knowledgeable about the routes to the Jyotirlingas. They ensure your journey is safe, timely, and spiritually fulfilling, with a focus on providing the utmost comfort throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive pricing for Pune to 5 Jyotirlinga Darshan Bus Hire. We provide upfront pricing with no hidden charges, allowing you to plan your pilgrimage without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "We maintain high standards of cleanliness and maintenance for our buses, ensuring a hygienic and comfortable environment throughout your journey to the 5 Jyotirlingas."
  },
  {
    "WhyChooseheading": "Flexible Scheduling and Pick-Up Points",
    "WhyChoosedescription": "We offer flexible pick-up points and scheduling options to suit your needs. Whether you're departing from a specific location in Pune or need a customized travel plan, we cater to all your requirements."
  },
  {
    "WhyChooseheading": "Customizable Itinerary for Your Pilgrimage",
    "WhyChoosedescription": "Our itineraries are flexible and can be customized to fit your desired schedule. You can choose the number of days, specific routes, and stops, ensuring a personalized pilgrimage experience to the 5 Jyotirlingas."
  },
  {
    "WhyChooseheading": "Easy Booking and Full Support",
    "WhyChoosedescription": "Booking your Pune to 5 Jyotirlinga Darshan Bus Hire is quick and hassle-free with Amruta Travels. Our dedicated customer support team is available to assist you with bookings, planning, and any other requirements throughout your journey."
  }
]




































    }

const faqData = [
  {
    question: 'How can I hire a bus for a 5 Jyotirlinga Darshan trip from Pune?',
    answer: 'Hiring a bus for your 5 Jyotirlinga Darshan trip from Pune with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll help you choose the right bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to 5 Jyotirlinga Darshan trip?',
    answer: 'We offer a variety of buses, including 32, 35, 45, and 50-seater options. Whether you prefer a standard or luxury bus, we have vehicles to suit your needs and make your pilgrimage comfortable and convenient.',
  },
  {
    question: 'How long does it take to complete the 5 Jyotirlinga Darshan trip?',
    answer: 'The 5 Jyotirlinga Darshan trip typically takes around 7-10 days, depending on the route and stops at each temple. The duration of the trip can vary based on your schedule and preferences.',
  },
  {
    question: 'Are the buses comfortable for the long journey to the 5 Jyotirlingas?',
    answer: 'Yes, all our buses are well-maintained and come with comfortable seating, air conditioning, and spacious interiors, ensuring that you have a relaxed and pleasant journey to each of the Jyotirlingas.',
  },
  {
    question: 'Can I book a bus for a customized 5 Jyotirlinga Darshan itinerary?',
    answer: 'Yes, we offer flexible itineraries for your 5 Jyotirlinga Darshan trip. We can customize the trip according to your preferred schedule and the temples you would like to visit.',
  },
  {
    question: 'Do you provide luxury buses for the 5 Jyotirlinga Darshan trip?',
    answer: 'Yes, we provide both standard and luxury buses for the 5 Jyotirlinga Darshan trip. Our luxury buses come with additional amenities such as premium seating, air conditioning, and more, making your journey even more comfortable.',
  },
  {
    question: 'How much does it cost to hire a bus for the 5 Jyotirlinga Darshan trip from Pune?',
    answer: 'The cost depends on the bus size, duration of the trip, and any additional services you may need. Please contact us for a detailed quote based on your specific travel requirements.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the 5 Jyotirlinga trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Share your preferred locations with us, and we’ll plan the best route for your trip to the 5 Jyotirlingas.',
  },
  {
    question: 'Why should I choose Amruta Travels for the 5 Jyotirlinga Darshan bus hire?',
    answer: 'Amruta Travels offers reliable, comfortable, and safe bus services for your 5 Jyotirlinga Darshan trip. Our buses are well-maintained, our drivers are experienced, and we ensure that your pilgrimage is smooth and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vijay Kulkarni',
    role: 'Devotee, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for our 5 Jyotirlinga Darshan trip. The bus was comfortable and well-maintained, and the driver was experienced and friendly. The trip was well-organized and enjoyable. Highly recommend their service for pilgrimage tours!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti Deshmukh',
    role: 'Pilgrimage Coordinator, Pune',
    text: 'Amruta Travels made our 5 Jyotirlinga Darshan trip memorable. The luxury bus was equipped with all the amenities we needed for such a long journey. The driver was well-informed and ensured a safe trip. We had a wonderful experience and would recommend their services to others.',
    rating: 5,
  },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to 5 Jyotirlinga Darshan Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-5-jyotirlinga-darshan-bus-hire.jpg",
  "description": "Book a bus for a spiritual journey to the 5 Jyotirlingas in Maharashtra from Pune. Visit Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and other sacred temples in a comfortable and affordable bus.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5321"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-5-jyotirlinga-darshan-bus-hire"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to 5 Jyotirlinga Darshan Bus Hire | Affordable & Comfortable Travel | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a bus for your spiritual journey to the 5 Jyotirlingas from Pune. Visit sacred temples like Trimbakeshwar, Bhimashankar, and Grishneshwar with Amruta Travels' affordable and comfortable buses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetojyotilingadarshan;